import type { LabelInValue } from 'models';
import { useMutation } from 'query';
import { createTelehealthRequestVisit } from '../../services';

export type TelehealthRequestVisitData = {
  medicalGroup: LabelInValue;
  reason: string;
  visitType: {
    name: string;
    translations: Translations;
  };
  visitTypeSubOption?: {
    name: string;
    translations: Translations;
  };
  visitTypeSubSubOption?: {
    name: string;
    translations: Translations;
  };
};

type Translations = {
  en: string;
  es: string;
};

export const useCreateTelehealthRequestVisit = () =>
  useMutation<unknown, TelehealthRequestVisitData>({
    async mutationFn({ medicalGroup, reason, visitType, visitTypeSubOption, visitTypeSubSubOption }) {
      await createTelehealthRequestVisit({
        body: {
          medicalGroup: medicalGroup.value,
          medicalGroupName: typeof medicalGroup.label === 'string' ? medicalGroup.label : '',
          reason,
          serviceTypes: [
            visitType,
            ...(visitTypeSubOption ? [visitTypeSubOption] : []),
            ...(visitTypeSubSubOption ? [visitTypeSubSubOption] : []),
          ],
        },
      });
    },
  });
